import React, { useState, useEffect } from 'react';
import {
  DialogActions,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Box,
} from '@mui/material';
import DraggableModal from '../../components/DraggableModal';
import { RowSpacing } from './RowSpacing';

const FieldCreation = ({ field, growerName, close, save }) => {
  const [record, setRecord] = useState({
    fieldName: '',
    farmName: '',
    plannedCrop: '',
    rowSpacing: '',
    irrigated: '',
  });

  useEffect(() => {
    setRecord(field);
  }, [field]);

  const getChangeHandler = (prop) => (e) => {
    const value = e.target.value;

    setRecord({
      ...record,
      [prop]: value,
    });
  };

  const validationErrors = {};
  if (!record.fieldName) {
    validationErrors.fieldName = 'Required';
  }

  const isValid = Object.keys(validationErrors).length === 0;

  return (
    <DraggableModal
      title={
        <span>
          Create New Field for <b>{growerName}</b>
        </span>
      }
      handleClose={close}
      noMinHeight={true}
    >
      <Box>
        <TextField
          variant="standard"
          label="Field Name"
          id="fieldname"
          value={record.fieldName || ''}
          onChange={getChangeHandler('fieldName')}
          required
        />
      </Box>
      <Box>
        <TextField
          variant="standard"
          label="Farm Name"
          value={record.farmName || ''}
          onChange={getChangeHandler('farmName')}
        />
      </Box>
      <Box>
        <FormControl variant="standard" sx={{ minWidth: 166 }}>
          <InputLabel id="plannedcrop">Planned Crop</InputLabel>
          <Select
            id="plannedcrop"
            value={record.plannedCrop || ''}
            onChange={getChangeHandler('plannedCrop')}
          >
            <MenuItem value="" key="none"></MenuItem>
            <MenuItem value="corn" key="corn">
              Corn
            </MenuItem>
            <MenuItem value="soy" key="soy">
              Soy
            </MenuItem>
            <MenuItem value="wheat" key="wheat">
              Wheat
            </MenuItem>
            <MenuItem value="other" key="other">
              Other
            </MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Box>
        <RowSpacing
          value={record.rowSpacing || ''}
          onChange={getChangeHandler('rowSpacing')}
        />
      </Box>
      <Box>
        <FormControl variant="standard" sx={{ minWidth: 166 }}>
          <InputLabel id="irrigated">Irrigated</InputLabel>
          <Select
            id="irrigated"
            value={record.irrigated || ''}
            onChange={getChangeHandler('irrigated')}
          >
            <MenuItem value="" key="none"></MenuItem>
            <MenuItem value="yes" key="yes">
              Yes
            </MenuItem>
            <MenuItem value="no" key="no">
              No
            </MenuItem>
          </Select>
        </FormControl>
      </Box>
      <DialogActions>
        <Button
          color="inherit"
          variant="outlined"
          onClick={(e) => {
            save(record);
            close(e);
          }}
          disabled={!isValid}
        >
          Continue
        </Button>
        <Button onClick={close} color="inherit" variant="outlined">
          Close
        </Button>
      </DialogActions>
    </DraggableModal>
  );
};

export default FieldCreation;
